import { axios } from 'api'
import React, { useState, useEffect, useMemo } from 'react'
import BrowseOptions from './BrowseOptions'
import { CoachTileGrid, CoachTileList } from './CoachListComponents'
import { useTitle } from 'hooks/useMetaTitle'

const SORT_OPTIONS = {
  az: (a, b) => a.user?.name.localeCompare(b.user?.name),
  date: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  rank: (a, b) => a.coachRank - b.coachRank
}

const CoachInfoView = () => {
  const [coaches, setCoaches] = useState([])
  const [layout, setLayout] = useState('tile')
  const [sortBy, setSortBy] = useState('az')
  useTitle('Yoga, Fitness, & Mindfulness Instructors')

  useEffect(() => {
    window.dataLayer ||= []
    window.dataLayer.push({
      page: 'instructorsList'
    })
    axios
      .get('/coaches/list', { load: true })
      .then((res) => {
        setCoaches(res.data)
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ page: 'instructorsList' })
  }, [])

  const sortedCoaches = useMemo(
    () => [...coaches].sort(SORT_OPTIONS[sortBy] || SORT_OPTIONS['az']),
    [coaches, sortBy]
  )
  if (!(coaches?.length > 0)) return null

  return (
    <div className='new-explore explore-cold-start'>
      <div className='grey-cover-header'>
        <div className='grey-centered-content'>
          <div className='grey-cover-content'>
            <h1>Instructors</h1>
          </div>
        </div>
      </div>

      <div className='section-container'>
        <div className='section-items-container'>
          <div className='container-fluid'>
            {/* SEO-friendly list (hidden) */}
            <ul style={{ display: 'none' }}>
              {sortedCoaches.map((coach) => (
                <li key={coach.slug}>
                  <a href={`/coaches/${coach.slug}`}>{coach.user.name}</a>
                </li>
              ))}
            </ul>

            <div className='coaches-top products-top'>
              <BrowseOptions
                sortBy={sortBy}
                onSortChange={setSortBy}
                layout={layout}
                onLayoutChange={setLayout}
              />
            </div>

            <div className='content-container'>
              {layout === 'tile' && (
                <div className='coaches-grid coach-filter'>
                  {sortedCoaches.map((coach) => (
                    <CoachTileGrid coach={coach} key={coach.slug} />
                  ))}
                </div>
              )}

              {layout === 'list' && (
                <div className='coach-cards' data-refmarks-prefix='bb_ch_list'>
                  {sortedCoaches.map((coach, index) => (
                    <CoachTileList
                      key={coach.slug}
                      coach={coach}
                      index={index}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoachInfoView
